<template>
  <div class="bg-gray-900 p-4 rounded-lg">
    <!-- تصویر محصول -->
    <div class="w-full h-48 mb-4 flex justify-center items-center">
      <img 
        class="object-contain max-h-full max-w-full" 
        :src="`${baseurl}/${product.imageUrl}`" 
        @click="showModal = true" 
        @error="$event.target.src = require('@/assets/placeholder.png')"
      />
    </div>

    <!-- نام و قیمت محصول -->
    <h1 class="text-white text-lg center-text">{{ product.name }}</h1>
    <h5 class="text-yellow-500 text-sm mt-2 center-text">
      {{ $t('Price') }}: {{ $helper.priceFormatter(product.price) }} {{ currency }}
    </h5>

    <!-- توضیحات و تگ‌های محصول -->
    <div v-if="!!product.serviceTagList[0]" class="text-gray-400 text-xs mt-2">
      <p>شرح:</p>
      <div class="flex flex-wrap">
        <span v-for="tag in product.serviceTagList" :key="tag" class="bg-green-500 text-white text-xs py-1 px-2 rounded-lg mr-2">{{ tag }}</span>
      </div>
    </div>

    <!-- مودال تصویر -->
    <modal v-if="showModal" :src="`${baseurl}/${product.imageUrl}`" @close="showModal = false" />
  </div>
</template>

<script>
import Modal from './General/Modal.vue';

export default {
  name: 'VerticalFoodCard',
  components: { Modal },
  props: {
    product: Object,
    baseurl: String,
    currency: String
  },
  data() {
    return {
      showModal: false
    };
  }
};
</script>

<style scoped>
.object-contain {
  object-fit: contain;
}
.center-text {
  text-align: center;
}
</style>
